import { useMutation } from '@hooks/reactQuery';

import { createNoFileRules } from '@api/alarmManagement';

import { IAlarmCreateNoVeRuleDTO } from '@interfaces/alarms/dto/alarmsDTO';

import { ALARM_CREATE_NO_FILE_RULE_ORAN } from '@constants/queryKeys';

interface IUseMutateAlarmsCreateNoFileRulesReturn {
	addAlarmNoFileRules: (data: IAlarmCreateNoVeRuleDTO[]) => void;
	isLoadingAddAlarmNoFileRules: boolean;
}

export const useMutateAlarmsCreateNoFileRules = (): IUseMutateAlarmsCreateNoFileRulesReturn => {
	const {
		mutateAsync,
		isLoading,
	} = useMutation<IAlarmCreateNoVeRuleDTO[]>({
		mutationKey: [ALARM_CREATE_NO_FILE_RULE_ORAN],
		mutationFn: createNoFileRules,
	});

	return {
		addAlarmNoFileRules: mutateAsync,
		isLoadingAddAlarmNoFileRules: isLoading,
	};
};
